import "./App.css";
import Board from "./PathVisualizer/Board";

function App() {
  return (
    <div className="App unselectable">
      <Board></Board>
    </div>
  );
}

export default App;
